import $ from "jquery";

$(document).ready(function (){
    $('.click-spin').on('click', function() {
        $('.modal-spinner').modal('show');
        setTimeout(function () {
            $('.modal-spinner').modal('hide');
        }, 6000);
    });
});
